import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "types";
import { initialState } from "app/containers/Features/components/MemberSelection/redux/initialState";


const selectDomain = (state: RootState) => state.memberListSlice || initialState;

export const selectMemberLoading = createSelector(
  [selectDomain],
  (state) => state.isLoading
);

export const selectProjectMemberList = createSelector([selectDomain], (state) => state.projectMemberList);

export const selectTeamMemberList = createSelector([selectDomain], (state) => state.teamMemberList);
